import React from 'react';
import { Switch, Route } from 'react-router-dom';

import { routes } from '../../../index';
import List from './List';
import Create from './Create';
import Edit from './Edit';

const CEUs = (props) => (
  <Switch>
    <Route exact path={routes.ceus.group.root} render={() => <List {...props} />} />
    <Route exact path={routes.ceus.group.add} render={() => <Create {...props} />} />
    <Route path={routes.ceus.group.edit} render={() => <Edit {...props} />} />
  </Switch>
);

export default CEUs;
